<div class="empty-state-wrap">
  <div class="empty-state-card" [class.marg-top]="isCreateOrder">

    <div class="empty-state-icon">
      <img class="empty-state-img" src="/assets/e-commerce/icons/65.webp" alt="empty addresses" />
    </div>

    <h2 class="empty-state-title">
      {{ "No addresses" | transloco }}
    </h2>

    <p class="empty-state-subtitle">
      {{ "Add your address now to complete your orders faster" | transloco }}
    </p>

    <button class="empty-state-btn" routerLink="/addaddress">
      {{ "Add Address" | transloco }}
    </button>
  </div>
</div>